export enum BOOK_TYPE {
    physical = 'physical',
    digital = 'digital',
    audio = 'audio',
    web = 'web',
    webDayPass = 'web-day-pass',
    webWeekPass = 'web-week-pass',
    webChapterOne = 'web-chapter-1',
    webChapterTwo = 'web-chapter-2',
    webChapterThree = 'web-chapter-3',
    webChapterFour = 'web-chapter-4',
    webChapterFive = 'web-chapter-5',
    webChapterSix = 'web-chapter-6',
    webChapterSeven = 'web-chapter-7',
    webChapterEight = 'web-chapter-8',
    webChapterNine = 'web-chapter-9',
    webChapterTen = 'web-chapter-10',
    webChapterEleven = 'web-chapter-11',
    webChapterTwelve = 'web-chapter-12',
    webChapterThirteen = 'web-chapter-13',
    webChapterFourteen = 'web-chapter-14',
    webChapterFifteen = 'web-chapter-15',
    webChapterSixteen = 'web-chapter-16',
    webChapterSeventeen = 'web-chapter-17',
    webChapterEighteen = 'web-chapter-18',
    webChapterNineteen = 'web-chapter-19',
    webAppendixA = 'web-appendix-a',
}
